import { Vehicle } from '../types';

/**
 * Human-readable label for an asset (vehicle or equipment).
 * - Cars/trucks: "YEAR MAKE MODEL" (unchanged behavior).
 * - Equipment: "MAKE MODEL · SERIAL" (falls back to description / "Equipment").
 */
export function assetLabel(v?: Partial<Vehicle> | null): string {
  if (!v) return '';
  if (v.asset_type === 'equipment') {
    const base = [v.make, v.model].filter(Boolean).join(' ').trim();
    const tail = v.serial_number
      ? ` · ${v.serial_number}`
      : v.asset_description
      ? ` · ${v.asset_description}`
      : '';
    return (base || v.asset_description || 'Equipment') + tail;
  }
  return [v.year, v.make, v.model].filter(Boolean).join(' ').trim();
}
